import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Box, Stack } from 'styled-system/jsx';
import { css } from 'styled-system/css';
import Typography from '@/common/components/base/typography/Typography.tsx';
import type { Swiper as SwiperType } from 'swiper';

const SwiperCustom = ({
  imageSliderData,
  handleSwiperIndex,
  onSwiperInit,
}: {
  imageSliderData: { image: string; title: string; doc: string }[];
  handleSwiperIndex: (index: number) => void;
  onSwiperInit: (swiper: SwiperType) => void;
}) => (
  <Swiper
    onSlideChange={(e) => {
      handleSwiperIndex(e.realIndex);
    }}
    modules={[Pagination]}
    onSwiper={onSwiperInit}
    zoom
    slidesPerView={1}
    dir="rtl"
    pagination={{
      el: '#containerForBullets',
      clickable: true,
      renderBullet: function (_index: number, className) {
        return '<span class="' + className + '">' + '' + '</span>';
      },
    }}
  >
    {imageSliderData.map((item) => (
      <SwiperSlide key={item.title}>
        <Box>
          <Box mb="20px">
            <img className={css({ width: '100%' })} src={item.image} alt="" />
          </Box>
          <Stack alignItems="center">
            <Typography color="purple-primary" textStyle="h1">
              {item.title}
            </Typography>
            <p className={css({ textStyle: 'b2', color: 'black-2' })}>
              {item.doc}
            </p>
          </Stack>
        </Box>
      </SwiperSlide>
    ))}
  </Swiper>
);
export default SwiperCustom;
